import styled from 'styled-components'

export const ScrollBlock = styled.div`
  position: relative;
`
